import React from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import useTour from './useTour';

/**
 * "?" Help button for the header bar.
 * Clicking it starts the Driver.js guided tour for the current page.
 */
const HelpButton = () => {
  const { startTour, tourConfig } = useTour();

  if (!tourConfig) return null;

  return (
    <button
      onClick={startTour}
      title={`Page Guide: ${tourConfig.title || 'Help'}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 14px',
        backgroundColor: 'rgba(21, 175, 83, 0.1)',
        border: '1px solid rgba(21, 175, 83, 0.25)',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '13px',
        fontWeight: '600',
        color: '#15af53',
        transition: 'all 0.2s',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.backgroundColor = 'rgba(21, 175, 83, 0.2)';
        e.currentTarget.style.borderColor = 'rgba(21, 175, 83, 0.4)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.backgroundColor = 'rgba(21, 175, 83, 0.1)';
        e.currentTarget.style.borderColor = 'rgba(21, 175, 83, 0.25)';
      }}
    >
      <FaQuestionCircle style={{ fontSize: '14px' }} />
      <span>Page Guide</span>
    </button>
  );
};

export default HelpButton;
